import "../../styles/global.css";
import DownloadableTable from "./DataTable";
import { fetchQuestionAverageByStudent, fetchDemoQuestionAverageByStudent } from "../../api/individualApi";
import { fetchAllSubmissionDates, fetchAllDemoSubmissionDates, fetchCourseName } from "../../api/overviewApi";
import React, { useState, useEffect, useMemo } from "react";


const toRangeFromDates = (dates) => {
  const ts = (Array.isArray(dates) ? dates : [])
    .map((d) => Date.parse(d))
    .filter((n) => Number.isFinite(n));
  if (ts.length === 0) return [null, null];
  return [Math.min(...ts), Math.max(...ts)];
};

const Data = () => {

    const [allDates, setAllDates] = useState([]);
    const [studentQuestionAverage, setStudentQuestionAverage] = useState([]);
    const [error, setError] = useState(null);
    const [sessionInfo, setSessionInfo] = useState(null);
    const [courseName, setCourseName] = useState("Demo Course");

    useEffect(() => {
        const cached = localStorage.getItem('iTOOLS_sessionInfo');
        if (cached) {
            console.log("Using cached session info");
            setSessionInfo(JSON.parse(cached));
        } else {
            console.log("No cached session info found");
            setSessionInfo({ name: "Demo Course" }); // Fallback to demo
        }
    }, []);

    useEffect(() => {
        if (!sessionInfo) return;

        console.log("Fetching course name...");
        fetchCourseName(sessionInfo.courseId)
            .then((name) => {
                console.log("? Course name:", name);
                setCourseName(name);
            })
            .catch((err) => {
                console.error("Error fetching course name:", err);
            });
    }, [sessionInfo]);

    useEffect(() => {
        if (!sessionInfo) return;

        (async () => {
            try {
            const data = await fetchAllSubmissionDates(sessionInfo.courseId);
            const [minDate, maxDate] = toRangeFromDates(data?.dates);
            setAllDates([minDate, maxDate]);

            // Cold start: no submissions, don't call downstream APIs
            if (!Number.isFinite(minDate) || !Number.isFinite(maxDate)) {
                setStudentQuestionAverage([]);  // clear UI state
                return;
            }

            const startISO = new Date(minDate).toISOString();
            const endISO   = new Date(maxDate).toISOString();

            const resp = await fetchQuestionAverageByStudent(startISO, endISO, sessionInfo.courseId);
            setStudentQuestionAverage(resp?.student_question_stats || []);
            } catch (error) {
            console.error("Error fetching all submission dates:", error);
            setAllDates([null, null]);
            setStudentQuestionAverage([]);
            }
        })();
    }, [sessionInfo]);

    useEffect(() => {
        if (studentQuestionAverage.length > 0) {
            console.log("Fetched studentQuestionAverage:", studentQuestionAverage);
        }
    }, [studentQuestionAverage]);

    const reshapedData = useMemo(() => {
        const studentMap = {};
        for (const row of studentQuestionAverage) {
            const name = row.student_name || "Unknown";
            const code = row.group_code || "Unknown";
            const score = parseFloat(row.avg_score) || 0;

            if (!studentMap[name]) {
                studentMap[name] = { 
                    USER_NAME: name,
                    COURSE_DESCRIPTION: courseName || "Demo Course",
                };
            }

            studentMap[name][code] = score;
        }
        return Object.values(studentMap);
    }, [studentQuestionAverage]);

    return (
        <div className="wrapper">
            <h1 className="title">DOWNLOAD DATA PREVIEW</h1>
            <DownloadableTable data={reshapedData} />
        </div>
    );
};

export default Data;